import { inject, Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { LoadingState } from '@tsin-core/entities';
import { AttendanceService } from '@tsin-core/services/http/attendance.service';
import { GetAttendancesByApplication, GetAttendancesByAdministration, MarkAttendance } from './attendance.actions';
import { catchError, tap } from 'rxjs';
import { AttendanceRecord } from '@tsin-core/models/attendance.model';

export class AttendanceStateModel {
  public attendanceList!: AttendanceRecord[];
  public loading!: LoadingState;
}

const defaults = {
  attendanceList: [],
  loading: LoadingState.notLoading,
};

@State<AttendanceStateModel>({
  name: 'attendanceState',
  defaults
})
@Injectable()
export class AttendanceState {

  attendanceService: AttendanceService = inject(AttendanceService);

  @Selector()
  static listAttendances(state: AttendanceStateModel): any[] {
    return state.attendanceList ?? [];
  }

  @Selector()
  static getLoading(state: AttendanceStateModel): LoadingState {
    return state.loading;
  }

  @Action(GetAttendancesByAdministration)
  getAttendancesByAdministration(ctx: StateContext<AttendanceStateModel>, action: GetAttendancesByAdministration) {
    ctx.patchState({ loading: LoadingState.loadingList });
    return this.attendanceService.getAttendanceByAdministration(action.payload).pipe(
      tap((attendanceListResponse: any) => {
        const state = ctx.getState();
        console.log('the new value', attendanceListResponse)
        ctx.patchState({
          attendanceList: attendanceListResponse,
          loading: LoadingState.notLoading,
        });
        console.log('Updated State:', ctx.getState());
      }),
      catchError((error) => {
        ctx.patchState({ loading: LoadingState.notLoading });
        throw error;
      })
    );
  }

  @Action(GetAttendancesByApplication)
  getAttendancesByApplication(ctx: StateContext<AttendanceStateModel>, action: GetAttendancesByApplication) {
    ctx.patchState({ loading: LoadingState.loadingList });
    return this.attendanceService.getByApplicationId(action.payload).pipe(
      tap((newExamFeeData: any) => {
        const state = ctx.getState();
        const newExamFee = newExamFeeData.data;
        console.log('the new value', newExamFee)
        ctx.patchState({
          attendanceList: [...state.attendanceList, { ...newExamFee }],
          loading: LoadingState.notLoading,
        });
      }),
      catchError((error) => {
        ctx.patchState({ loading: LoadingState.notLoading });
        throw error;
      })
    );
  }

  @Action(MarkAttendance)
  markAttendance(ctx: StateContext<AttendanceStateModel>, action: MarkAttendance) {
    ctx.patchState({ loading: LoadingState.loadingAddUpdate });
    return this.attendanceService.markAttendance(action.payload).pipe(
      tap((updatedAttendance: any) => {
        const state = ctx.getState();
        // console.log('the new value', updatedAttendance)
        // Create a new object with updated attendance property
        const updatedAttendanceRecord = {
          ...updatedAttendance,
          attendance: action.payload.attendance
        };
        const attendances = state.attendanceList.map(
          (attendance) =>
            attendance.id === updatedAttendance.id
              ? updatedAttendanceRecord
              : attendance
        );

        // console.log('Attendance list is now ', attendances);
        ctx.patchState({
          attendanceList: attendances,
          loading: LoadingState.notLoading,
        });
      }),
      catchError((error) => {
        ctx.patchState({ loading: LoadingState.notLoading });
        throw error;
      })
    );
  }

}
